import { render, staticRenderFns } from "./teamIntroduce.vue?vue&type=template&id=3e306606&scoped=true&"
import script from "./teamIntroduce.vue?vue&type=script&lang=js&"
export * from "./teamIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./teamIntroduce.vue?vue&type=style&index=0&id=3e306606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e306606",
  null
  
)

export default component.exports